import { createContext } from 'react';
/**
 * Cтавит статусбар в цвет смеси оверлея и базового фона `--tui-background-base`
 * @default {({ theme }) => theme === 'light' ? '#404040' : '#080808';}
 */
export const defaultColorMixer = ({
  theme,
  overlayColor,
  metaColor,
  metaMedia
}) => {
  return theme === 'light' ? '#404040' : '#080808';
};
const defaultMetaThemeContext = {
  colorMixer: defaultColorMixer,
  enabled: false
};
export const MetaThemeContext = /*#__PURE__*/createContext(defaultMetaThemeContext);